export const needBeLoggedStyle = {
  wrapper: {},

  title: {
    textAlign: 'center',
    marginBottom: '8px',
  },

  afterTitle: {
    color: 'var(--neutral-300)',
    textAlign: 'center',
    marginBottom: '24px',
  },

  icon: {
    margin: '0 auto ',
    svg: {
      width: '60px',
      height: '60px',
    },
  },

  btnWrapper: {
    display: 'flex',
    gap: '24px',
    height: '44px',

    '@media (max-width: 639.98px)': {
      flexDirection: 'column',
      width: '100%',
    },
  },
  btn: {
    lineHeight: '16px',
    zIndex: 1,

    '@media (max-width: 639.98px)': {
      lineHeight: '24px',
      height: '44px',
    },
  },
  cancelBtn:{
    '@media (max-width: 639.98px)': {
      display: 'none',
    }
  }
};
